import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { ActivatedRoute, Router } from '@angular/router';
import { Location, DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { GridPageSettings, MenuFuncionCodes, TipoDocumento, SearchTipoDocumentoRequest, SavePersonaDto, SavePersonVerificationImageRequestDto, SearchEmpleadoItemDto, SearchEmpleadoRequestDto, DialogConfirmRequest, DialogConfirmResponse, LocalStorageKeys, SearchUnidadFuncionalRequest, SearchIncidenciaUsuarioRequestDto, SearchProveedorRequest, TenantFeatureFlags, Provincia, SearchProvinciaRequest, EstadoCivil, SearchEstadoCivilRequest, Pais, SearchPaisRequest, SearchPersonaRequestDto,
  Persona, SearchUsuariosItemDto, SearchUsuariosRequestDto
 } from '../../../../src/app/shared/model';
import { PersonaService, UsuarioService, MenuFuncionService, TipoDocumentoService, EmpleadoService, TenantService, UnidadFuncionalService, IncidenciaUsuarioService, ProveedorService, ProvinciaService, EstadoCivilService, PaisService } from '../../../../src/app/shared/services';
import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-personaEdit',
  templateUrl: './personaEdit.component.html',
  styleUrls: ['./personaEdit.component.scss']
})

export class PersonaEditComponent implements OnInit {
  personaFormGroup: FormGroup;
  personaId: number;

  public pageSettings: PageSettingsModel;
  public pageSizes: number[];
  public selectionOptions: SelectionSettingsModel;
  public toolbarOptions: ToolbarItems[];

  isValidating: boolean = false;
  isSearching: boolean = false;
  isUsuariosAsociadosSearching: boolean = false;
  isEmpleadosAsociadosSearching: boolean = false;
  isPersonSaving: boolean = false;
  isTipoDocumentoSearching: boolean = false;
  isPersonaSearching: boolean = false;
  isImageLoading: boolean = false;
  isUfsAsociadasSearching: boolean = false;
  isIncidenciasSearching: boolean = false;
  isProveedoresAsociadosSearching: boolean = false;
  isProvinciaSearching: boolean = false;
  isEstadoCivilSearching: boolean = false;
  isPaisSearching: boolean = false;
  isPersonaDataSearching: boolean = false;
  isDeleting: boolean = false;

  canEdit: boolean = false;
  canDelete: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;

  canViewUsuarios: boolean = false;
  canViewIncidencias: boolean = false;
  canViewProveedores: boolean = false;
  canViewUfs: boolean = false;
  canViewEmpleados: boolean = false;
  showCuit: boolean = false;

  tenantFeatureFlags: TenantFeatureFlags;

  activo: boolean = true;
  msgError: string = "";
  usuariosAsociadosError: string = "";
  empleadosAsociadosError: string = "";
  ufAsociadosError: string = "";
  proveedoresAsociadosError: string = "";

  persona: Persona = new Persona(null, null, null, null, null, null, null, null, null,  null,true, null,null, null);
  userImageExtension: string = "";

  tipoDocumentoList: TipoDocumento[];
  usuariosAsociadosList: any[];
  empleadosAsociadosList: any[];
  ufsAsociadasList: any[];
  incidenciasList: any[];
  proveedoresAsociadosList: any[];
  public provinciaList: Provincia[];
  public estadoCivilList: EstadoCivil[];
  public paisList: Pais[];
  personaSearchResult: Persona | null;

  userImageBase64: string | ArrayBuffer | null;

  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private router: Router,
    private datePipe: DatePipe,
    public tipoDocumentoService: TipoDocumentoService,
    private personaService: PersonaService,
    private menuService: MenuFuncionService,
    public usuarioService: UsuarioService,
    public proveedorService: ProveedorService,
    public unidadFuncionalService: UnidadFuncionalService,
    public incidenciaUsuarioService: IncidenciaUsuarioService,
    public tenantService: TenantService,
    public provinciaService: ProvinciaService,
    private estadoCivilService: EstadoCivilService,
    private paisService: PaisService,
    public empleadoService: EmpleadoService) {
  }

  ngOnInit(): void {

    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.PERSONA).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.isValidating = false;
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canEdit = data.Result.some(x => x == MenuFuncionCodes.PERSONA_EDIT);
            this.canAdd = data.Result.some(x => x == MenuFuncionCodes.PERSONA_ADD);
            this.canView = data.Result.some(x => x == MenuFuncionCodes.PERSONA_LIST);
            this.canDelete = data.Result.some(x => x == MenuFuncionCodes.PERSONA_DELETE);

            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isSearching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.puedeVerUsuarios();
    this.puedeVerIncidencias();
    this.puedeVerEmpleados();
    this.puedeVerUfs();
    this.puedeVerProveedores();

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };

    if (this.canAdd || this.canEdit) {
      this.buildPersonForm();
      this.getTiposDocumento();
      this.getProvincias();
      this.getEstadoCivil();
      this.getPaises();
    }

    this.loadEntity();
  }

  buildPersonForm() {
    this.personaFormGroup = this.formBuilder.group({
      'Nombre': [null, [Validators.required, Validators.maxLength(150)]],
      'Apellido': [null, [Validators.required, Validators.maxLength(150)]],
      'TipoDocumentoId': [null],
      'NroDocumento': [null, Validators.maxLength(100)],
      'Cuit': [null],
      'FechaNacimiento': [null],
      'MailContacto': [null, [Validators.maxLength(255), Validators.email]],
      'MovilContacto': [null, Validators.maxLength(100)],

      'DomicilioDni': [null, [Validators.maxLength(150)]],
      'CodigoPostalDni': [null, [Validators.maxLength(50)]],
      'DomicilioReal': [null, [Validators.maxLength(150)]],
      'CodigoPostalReal': [null, [Validators.maxLength(50)]],
      'PaisId': [null],

      'ProvinciaId': [null],
      'LocalidadBarrio': [null],
      'ProvinciaRealId': [null],
      'LocalidadBarrioReal': [null, [Validators.maxLength(100)]],
      'EstadoCivilId': [null],
      'MovilContactoOtro': [null]
    });
  }

  getPaises() {
    var r = new SearchPaisRequest(null, null, true, "Nombre", null, null, true);
    this.isPaisSearching = true;

    this.paisService.search(r).subscribe(data => {
      this.isPaisSearching = false;
      if (data != null) {
        this.paisList = data?.result;
      }
    },
    (err: HttpErrorResponse) => {
      this.isPaisSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getProvincias() {
    this.isProvinciaSearching = true;
    var r = new SearchProvinciaRequest(null, null, true, "Nombre", null, null,null,true);
    this.provinciaService.search(r).subscribe(data => {
      this.isProvinciaSearching = false;
      if (data != null) {
        this.provinciaList = data?.result;
      }
    },
    (err: HttpErrorResponse) => {
      this.isProvinciaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getEstadoCivil() {
    this.isEstadoCivilSearching = true;
    var r = new SearchEstadoCivilRequest(null, null, true, "Nombre", null, null,true);
    this.estadoCivilService.search(r).subscribe(data => {
      this.isEstadoCivilSearching = false;
      this.estadoCivilList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isEstadoCivilSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getTiposDocumento() {
    var r = new SearchTipoDocumentoRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoDocumentoSearching = true;

    this.tipoDocumentoService.search(r).subscribe(data => {
      this.isTipoDocumentoSearching = false;
      if (data != null) {
        this.tipoDocumentoList = data?.result;
      }
    },
    (err: HttpErrorResponse) => {
      this.isTipoDocumentoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  isProcessing() {
    return (this.isSearching || this.isPersonSaving);
  }

  convertFileToBase64(event, fieldName) {
    this.userImageBase64 = null;
    const file = event.target.files[0];

    if (file != null) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // this.backofficeImageBase64 = reader.result;
      };
      reader.onloadend = () => {

        var imageBase64 = reader.result;
        var imageExtension = (file?.name?.split('.')?.pop() ?? "");

        switch (fieldName) {
          case "ImagenPerfil":
            this.userImageBase64 = imageBase64;
            this.userImageExtension = imageExtension;
            break;
          case "DniFrente":
          case "DniDorso":
          case "Selfie":
            this.cargarImagenVerificacion(fieldName, imageBase64, imageExtension);
            break;
        }
        // console.log(reader.result);
      };
    }
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        this.personaId = Number(params['id']);

        if (this.personaId > 0) {
          if(this.canView || this.canEdit) {
            this.isSearching = true;
            this.personaService.get(this.personaId).subscribe(data => {
              this.isSearching = false;
              if (data != null && data.Success) {
                this.persona = data.Result;

                if (this.persona != null && this.persona.Id != null && this.persona.Id > 0) {
                  if (this.canEdit) {
                    this.personaFormGroup.patchValue(this.persona);
                    this.personaFormGroup?.get("FechaNacimiento")?.setValue(this.datePipe.transform(this.persona.FechaNacimiento, "yyyy-MM-dd"));

                    this.getUsuariosAsociados();
                    this.getEmpleadosAsociados();
                    this.getUfsAsociadas();
                    this.getProveedoresAsociados();
                    this.getIncidencias(this.personaId);
                  }
                }
                else
                  this.msgError = "No se encontró la persona seleccionada.";
              }
              else
                this.msgError = "Ocurrió un error al intentar obtener los datos de la persona.";
            },
            (err: HttpErrorResponse) => {
              this.isSearching = false;
              this.sharedFunctions.handleError(err, true);
            })
          }
          else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.onCancel();
          }
        }
        else
          this.msgError = "Item no válido.";
      }
      else {
        if (this.canAdd) {
          this.persona = new Persona(null, null, null, null, null, null, null, null, null,null, true, null, null, null);
          this.personaFormGroup.patchValue(this.persona);
        }
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.onCancel();
        }
      }
    });
  }

  onTipoDocumentoSelection() {
    var tipoDoc: TipoDocumento | null = null;
    if (this.tipoDocumentoList != null)
      tipoDoc = (this.tipoDocumentoList.filter(f => f.Id == this.personaFormGroup?.get("TipoDocumentoId")?.value))[0];
    this.showCuit = !(tipoDoc?.Nombre?.toUpperCase() == "CUIT" || tipoDoc?.Nombre?.toUpperCase() == "CUIL");
    this.checkPersonaExistance(true, false);
  }

  onNroDocumentoChange() {
    this.checkPersonaExistance(true, false);
  }

  onCuitChange() {
    this.checkPersonaExistance(false, true);
  }

  checkPersonaExistance(searchByDoc: boolean, searchByCuit: boolean) {
    var tipoDocId = this.personaFormGroup?.get("TipoDocumentoId")?.value;
    var nroDoc = this.personaFormGroup?.get("NroDocumento")?.value;
    var cuit = this.personaFormGroup?.get("Cuit")?.value;

    if ((tipoDocId > 0 && nroDoc?.length > 0) || cuit?.length > 0) {
      var r = new SearchPersonaRequestDto(null, null, true, "Apellido", null, null, tipoDocId, nroDoc, null, null, null, true, false);
      if (searchByCuit)
        r = new SearchPersonaRequestDto(null, null, true, "Apellido", null, null, null, null, cuit, null, null, true, false);

      this.isPersonaDataSearching = true;

      this.personaService.search(r).subscribe(data => {
        this.isPersonaDataSearching = false;
        if (data != null && data.result != null && data.result.length > 0) {
          this.personaSearchResult = data?.result[0];

          if (this.personaSearchResult?.Id == this.persona?.Id) {
            this.personaSearchResult = null;
            return;
          }

          var msg = "Se encontró a la persona " + this.personaSearchResult?.Nombre + " " + this.personaSearchResult?.Apellido;
          if (searchByDoc) msg +=" en base al tipo y nro. de documento ingresado. ";
          if (searchByCuit) msg +=" en base al CUIT/CUIL ingresado. ";
          msg += "\n\n¿Desea cargar los datos encontrados?"

          const dialogRef = this.dialog.open(DialogConfirmComponent, {
            data: new DialogConfirmRequest("Persona encontrada", msg, "Sí, carga los datos", "No cargues nada")
          });

          dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
            if (result != null && result.Accepted)
              this.cargarPersonaEncontrada();
            else
              this.noCargarPersonaEncontrada();
          });
        }
      },
      (err: HttpErrorResponse) => {
        this.isPersonaDataSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }

  cargarPersonaEncontrada() {
    if (this.personaSearchResult != null && this.personaSearchResult.Id != null && this.personaSearchResult.Id > 0) {
      this.persona = this.personaSearchResult;
      this.personaFormGroup.patchValue(this.persona);

      this.personaSearchResult = null;
    }
  }

  noCargarPersonaEncontrada() {
    this.personaSearchResult = null;
  }

  puedeVerUsuarios() {
    this.menuService.checkMenuPadre(MenuFuncionCodes.USER).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewUsuarios = data.Result.some(x => x == MenuFuncionCodes.USER_LIST);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  puedeVerIncidencias() {
    this.menuService.checkMenuPadre(MenuFuncionCodes.INCIDENCIA_USUARIO).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewIncidencias = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_LIST) ||
            data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_LIST_BO);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  puedeVerEmpleados() {
    if (!this.tenantFeatureFlags?.HabilitarControlPedidos)
      return;

    this.menuService.checkMenuPadre(MenuFuncionCodes.EMPLEADO).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewEmpleados = data.Result.some(x => x == MenuFuncionCodes.EMPLEADO_LIST);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  puedeVerUfs() {
    this.menuService.checkMenuPadre(MenuFuncionCodes.UNIDAD_FUNCIONAL).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewUfs = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_LIST);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  puedeVerProveedores() {
    this.menuService.checkMenuPadre(MenuFuncionCodes.PROVEEDOR).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewProveedores = data.Result.some(x => x == MenuFuncionCodes.PROVEEDOR_LIST);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  getUsuariosAsociados() {
    if (this.personaId > 0) {
      var r = new SearchUsuariosRequestDto(null, null, true, "Login", null, null, null, null, null, null, this.personaId, null, null, true, null);
      this.isUsuariosAsociadosSearching = true;

      this.usuarioService.search(r).subscribe(data => {
        this.isUsuariosAsociadosSearching = false;
          if (data != null) {
            this.usuariosAsociadosList = data.result;
          }
          else
            this.usuariosAsociadosError = "Ocurrió un error al intentar obtener los datos de los usuarios.";
      },
      (err: HttpErrorResponse) => {
        this.isUsuariosAsociadosSearching = false;
        this.sharedFunctions.handleError(err, true);
      })
    }
  }

  getEmpleadosAsociados() {
    if (!this.tenantFeatureFlags?.HabilitarControlPedidos)
      return;

    if (this.personaId > 0) {
      var r = new SearchEmpleadoRequestDto(50, null, true, "Nombre", this.personaId, null, null, null, null, null, null, null, null, null, null, false, true);
      this.isEmpleadosAsociadosSearching = true;

      this.empleadoService.search(r).subscribe(data => {
        this.isEmpleadosAsociadosSearching = false;
          if (data != null) {
            this.empleadosAsociadosList = data.result;
          }
          else
            this.empleadosAsociadosError = "Ocurrió un error al intentar obtener los datos de los empleados.";
      },
      (err: HttpErrorResponse) => {
        this.isEmpleadosAsociadosSearching = false;
        this.sharedFunctions.handleError(err, true);
      })
    }
  }

  getUfsAsociadas() {
    if (!this.tenantFeatureFlags?.HabilitarGestionUf)
      return;

    if (this.personaId > 0) {
      var r = new SearchUnidadFuncionalRequest(50, null, true, "Codigo", null, null, null, this.personaId, null, null, null, null, true);
      this.isUfsAsociadasSearching = true;

      this.unidadFuncionalService.search(r).subscribe(data => {
        this.isUfsAsociadasSearching = false;
          if (data != null) {
            this.ufsAsociadasList = data.result;
          }
          else
            this.ufAsociadosError = "Ocurrió un error al intentar obtener los datos de las UFs.";
      },
      (err: HttpErrorResponse) => {
        this.isUfsAsociadasSearching = false;
        this.sharedFunctions.handleError(err, true);
      })
    }
  }

  getProveedoresAsociados() {
    if (this.personaId > 0) {
      var r = new SearchProveedorRequest(50, null, true, "RazonSocial", null, null, null, this.personaId, null, null, true);
      this.isProveedoresAsociadosSearching = true;

      this.proveedorService.search(r).subscribe(data => {
        this.isProveedoresAsociadosSearching = false;
          if (data != null) {
            this.proveedoresAsociadosList = data.result;
          }
          else
            this.proveedoresAsociadosError = "Ocurrió un error al intentar obtener los datos de los proveedores.";
      },
      (err: HttpErrorResponse) => {
        this.isProveedoresAsociadosSearching = false;
        this.sharedFunctions.handleError(err, true);
      })
    }
  }

  getIncidencias(id: number) {
    var r = new SearchIncidenciaUsuarioRequestDto(null, null, true, "FechaUltimoMensaje", null, null, null, null, null, null, null, null, null, id, null, null, null, null, null, null);
    this.isIncidenciasSearching = true;

    this.incidenciaUsuarioService.search(r).subscribe(data => {
      this.isIncidenciasSearching = false;
      this.incidenciasList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isIncidenciasSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.personaFormGroup?.get(formFieldName) != null && this.personaFormGroup?.get(formFieldName)?.value)
        this.personaFormGroup?.get(formFieldName)?.setValue(null);
    }
  }

  getErrorNombre() {
    var v = this.personaFormGroup?.get('Nombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorApellido() {
    var v = this.personaFormGroup?.get('Apellido');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorProvincia() {
    var v = this.personaFormGroup?.get('ProvinciaId');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorProvinciaReal() {
    var v = this.personaFormGroup?.get('ProvinciaRealId');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErroMovilContactoOtrol() {
    var v = this.personaFormGroup?.get('MovilContactoOtro');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorFechaNacimiento() {
    return this.personaFormGroup?.get('FechaNacimiento')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorTipoDocumentoId() {
    return this.personaFormGroup?.get('TipoDocumentoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorNroDocumento() {
    var v = this.personaFormGroup?.get('NroDocumento');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorCuit() {
    return this.personaFormGroup?.get('Cuit')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorMailContacto() {
    var v = this.personaFormGroup?.get('MailContacto');
    if (v?.hasError('maxlength'))
      return 'Límite de 255 caracteres alcanzado';
    if (v?.hasError('email'))
      return 'Debe ingresar un email con formato válido';
    return '';
  }

  getErrorMovilContacto() {
    var v = this.personaFormGroup?.get('MovilContacto');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorEstadoCivilId() {
    var v = this.personaFormGroup?.get('EstadoCivilId');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

//#region FORM ERRORS <SECCION DOMICILIO>
  getErrorDomicilioDni() {
    var v = this.personaFormGroup?.get('DomicilioDni');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorCodigoPostalDni() {
    var v = this.personaFormGroup?.get('CodigoPostalDni');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 50 caracteres alcanzado';
    return '';
  }

  getErrorLocalidadBarrio() {
    var v = this.personaFormGroup?.get('LocalidadBarrio');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorDomicilioReal() {
    var v = this.personaFormGroup?.get('DomicilioReal');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorCodigoPostalReal() {
    var v = this.personaFormGroup?.get('CodigoPostalReal');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 50 caracteres alcanzado';
    return '';
  }

  getErrorLocalidadReal() {
    var v = this.personaFormGroup?.get('LocalidadBarrioReal');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }
//#endregion

  hasPersonaFotoDniFrente() {
    return (this.persona?.FotoDniFrenteUrl != null && this.persona?.FotoDniFrenteUrl.length > 0);
  }

  hasPersonaFotoDniDorso() {
    return (this.persona?.FotoDniDorsoUrl != null && this.persona?.FotoDniDorsoUrl.length > 0);
  }

  hasPersonaFotoSelfie() {
    return (this.persona?.FotoSelfieUrl != null && this.persona?.FotoSelfieUrl.length > 0);
  }

  onGuardarPersona() {
    if (!this.personaFormGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var r = new SavePersonaDto(0, null, null, null, null, null, null, null, null, true, null, null, null, null, null, null);

    r =
    {
      ...this.personaFormGroup.value,
      ...
      {
        Id: (this.persona?.Id ?? 0),
        Activo: this.persona.Activo
      }
    };

    this.isPersonSaving = true;
    this.personaService.save(r).subscribe(data => {
      this.isPersonSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isPersonSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCancel() {
    this.location.back();
  }

  editUser(item: SearchUsuariosItemDto) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (!this.canViewUsuarios)
      return false;

    this.router.navigate(['usuario-edit', item.Id]);
  }

  editEmpleado(item: SearchEmpleadoItemDto) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (!this.canViewEmpleados)
      return false;

    this.router.navigate(['empleado-edit', item.Id]);
  }

  editProveedor(item: any) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (!this.canViewProveedores)
      return false;

    this.router.navigate(['proveedor-edit', item.Id]);
  }

  editUf(item: any) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (!this.canViewUfs)
      return false;

    this.router.navigate(['unidad-funcional-edit', item.Id]);
  }

  editIncidencia(item: any) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (!this.canViewIncidencias)
      return false;

    this.router.navigate(['incidencia-usuario-edit', item.Id]);
  }

  cargarImagenVerificacion(fieldName, imageBase64, imageExtension) {
    if (fieldName != null && fieldName.length > 0 && imageBase64 != null && imageBase64.length > 0 && imageExtension != null && imageExtension.length > 0 && this.persona.Id != null) {

      var index = imageBase64?.toString()?.indexOf(",");
      imageBase64 = (index != null && index >= 0 ? imageBase64?.toString()?.substring(index + 1) : null);

      var r = new SavePersonVerificationImageRequestDto(this.persona.Id, fieldName, imageBase64, imageExtension);
      this.isImageLoading = true;

      this.personaService.saveVerificationImagen(r).subscribe(data => {
        this.isImageLoading = false;
        if (data != null && data.Success && data.Result != null) {
          switch (fieldName) {
            case "DniFrente":
              this.persona.FotoDniFrenteUrl = data.Result;
              break;
            case "DniDorso":
              this.persona.FotoDniDorsoUrl = data.Result;
              break;
            case "Selfie":
              this.persona.FotoSelfieUrl = data.Result;
              break;
          }

          this.sharedFunctions.showMessage("Se cargó la imagen exitosamente!", "Imagen cargada");
        }
        else
          this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
      },
      (err: HttpErrorResponse) => {
        this.isImageLoading = false;
        this.sharedFunctions.handleError(err, true);
      })
    }
  }

  onDelete() {
    if (!this.canDelete)
      return false;

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(null, "¿Está seguro que desea eliminar la persona?", null, null)
    });
    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted && this.persona.Id != null) {
        this.isDeleting = true;
        this.personaService.delete(this.persona.Id).subscribe(data => {
          this.isDeleting = false;
          if (data != null && data.Success && data.Result) {
            this.sharedFunctions.showMessage("Se eliminaron correctamente los datos!", "Operación Exitosa!");
            this.onCancel();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isDeleting = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    });
  }
}
